/*global page */
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  fc.wizard = {
    eventHandlers: [{
      event: 'click',
      target: '.prevstep',
      handler: function (e) {
        if (this.currentStep > 0) {
          this.currentStep -= 1;
          this.renderMiddle();
        } else if (this.redirectedFrom) {
          page(this.redirectedFrom);
        }
      }
    }, {
      event: 'click',
      target: '.nextstep',
      handler: function (e) {
        if (this.currentStep < this.maxStep) {
          this.currentStep += 1;
          this.renderMiddle();
        } else {
          page(this.redirectTo);
        }
      }
    }],
    renderMiddle: function () {
      var contentMiddle = this.$$('.content');
      if (contentMiddle) {
        contentMiddle.innerHTML = this.middleContent[this.currentStep];
      }

      let prevArrow = this.$$('.prevstep');

      if (this.currentStep === 0 && !this.redirectedFrom) {
        prevArrow.classList.add('hidden');
      } else {
        prevArrow.classList.remove('hidden');
      }
    },
    getHtml: function (redirectTo) {
      return `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content"></div><div class="prevstep"><img src="/assets/app/arrow2.svg"></div><div class="nextstep"><img src="/assets/app/arrow1.svg"></div><footer><a href="${redirectTo}"><small>Skip</small><img src="/assets/app/arrow3.svg"></a></footer>`;
    },
    run: function () {
      this.renderMiddle();
    }
  };
}(FakeCation));
